import every from "lodash/every";
import some from "lodash/some";
import { checkMask } from "./permissionsTree/utils";
import { getCookieClientAuth } from "Common/cookies";
export class Security {
    constructor(clientAuth) {
        this.adminUserId = 1;
        this.adminRoleId = 1;
        this.check = (permissionsToCheck) => {
            const { authToken } = this;
            return (authToken === null || authToken === void 0 ? void 0 : authToken.Permissions) && checkMask(authToken.Permissions, permissionsToCheck);
        };
        this.getCurrentUserId = () => { var _a; return ((_a = this.authToken) === null || _a === void 0 ? void 0 : _a.Id) || 0; };
        this.isAllowed = (permissions) => every(permissions, this.check);
        this.isAllowedAny = (permissions) => some(permissions, this.check);
        this.userLogin = () => {
            const { authToken } = this;
            return authToken && authToken.Login;
        };
        this.authToken = clientAuth;
    }
}
export default new Security(getCookieClientAuth());
